var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarStaffDetailsListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29395 2.25V3.59961H11.6846V2.25H13.0332V3.59961C15.539 3.59966 15.7285 4.0226 15.7285 5.42773C15.7285 5.86762 15.75 13.9681 15.75 14.2383C15.75 15.0604 15.2105 15.75 14.4658 15.75H3.68359C2.93958 15.75 2.29297 14.9835 2.29297 14.2383L2.25 4.9502C2.25 4.20776 2.85643 3.59971 3.59766 3.59961H4.94531V2.25H6.29395ZM3.59766 9V13.7246C3.59766 14.0971 3.89961 14.4002 4.27148 14.4004H13.707C14.0775 14.4002 14.3809 14.0957 14.3809 13.7246V9H3.59766ZM4.25195 4.9502C3.89085 4.95034 3.59766 5.24376 3.59766 5.60547V7.65039H14.3809V5.625C14.3809 5.25252 14.0789 4.95039 13.707 4.9502H13.0332V6.2998H11.6846V4.9502H6.29395V6.2998H4.94531V4.9502H4.25195Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarStaffDetailsListing);
export default __webpack_public_path__ + "static/media/calendar_staff_details_listing.fb45c0d359eed2a2928f2e1616d6b710.svg";
export { ForwardRef as ReactComponent };